// Core
import { Link, NavLink, Route, Switch, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import React, { useState, useRef, useEffect, Suspense } from 'react';
import { Flex, Box, Image, Button, Text, useDisclosure } from '@chakra-ui/react';
import { RiMessage3Fill } from 'react-icons/ri';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { FaUserGroup } from 'react-icons/fa6';
//import { RiGamepadLine, RiGamepadFill } from 'react-icons/ri';
import { LuFerrisWheel } from 'react-icons/lu';
import { FaRegUser } from 'react-icons/fa';
import { TbCardsFilled, TbCards } from 'react-icons/tb';
import { TbMessage2Heart } from 'react-icons/tb';
import { TiGroupOutline } from 'react-icons/ti';
import { LiaUsersSolid } from 'react-icons/lia';
import { PiUsersThreeFill, PiUsersThreeBold } from 'react-icons/pi';
import { ReactComponent as TbMessage2HeartFilled } from '../../assets/svg/TbMessage2HeartFilled.svg';

// Components
import { people } from '../../variables/data';
import placeholderUser from 'assets/img/placeholder-user.png';

const Footer = ({object, isCheckedTypeAccount, setIsCheckedTypeAccount}) => {
  const active = 2;
  const colorIcon = '';
  const colorActiveIcon = '#0088cc';
  //const colorIcon = '#EA7FFC'; //'#27A5E5'; // TG Color 
  const borderRadius = '6px';
  const p = '6px';

  const { path, url } = useRouteMatch();

  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);

  const styleCenter = {
    background: 'linear-gradient(180deg, #ffffff 10%, transparent 70%)',
    borderRadius: '100%',
    padding: '4px',
    marginTop: '-20px',
    overflow: 'visible !important',
    borderTop: '1px solid #0088cc'
  };

  const styleCenterIn = {
    background: colorActiveIcon,
    borderRadius: '100%',
    padding: '16px',
  };

  return (
    <Box
        h="88px"
        className="footer-links"
        position="fixed"
        bottom="0"
        display={ !isCheckedTypeAccount || (isCheckedTypeAccount && location.pathname === '/') ? 'block' : 'none' }
        width="100%"
        background={
          location.pathname === '/profile' 
            || location.pathname === '/profile/balance' 
            || location.pathname === '/profile/settings' 
            || location.pathname === '/profile/gallery'
            || location.pathname === '/messages' 
            || location.pathname === '/group' 
          ? '#ffffff91' : 'transparent'}
        backdropFilter="blur(3px)"
        padding="8px 40px 30px 30px"
        textAlign="center"
        overflow="visible !important"
      > 
      { !isCheckedTypeAccount ? (
        <Flex alignItems="center" justifyContent='space-around' w="100%" overflow="visible !important">
          <Link to="/games">
            { isActive('games') ? 
              ( <Box p={p} borderRadius={borderRadius}><LuFerrisWheel color={colorActiveIcon} fontSize="32px" /></Box> ) : 
              ( <Box p={p} borderRadius={borderRadius}><LuFerrisWheel color={colorIcon} fontSize="32px" /></Box> )
            }
          </Link>

          <Link to="/" style={{ overflow: 'visible' }}>
            <Box p={p} borderRadius={borderRadius} style={styleCenter}><Box style={styleCenterIn}><TbCardsFilled color={'white'} fontSize="32px" /></Box></Box>
          </Link>

          <Link to="/profile" className={isActive('profile') ? 'menu-active' : ''}>
            { isActive('profile') ? 
              ( <Box p={p} borderRadius={borderRadius}><FaRegUser color={colorActiveIcon} fontSize="28px" /></Box> ) : 
              ( <Box p={p} borderRadius={borderRadius}><FaRegUser color={colorIcon} fontSize="28px" /></Box> )
            }
          </Link>

        </Flex>
      ) : (
        <NavLink to="/profile/groups">
           <Button mt="-16px" variant="button-lg" bg="#0088cc" _active={{background: '#0088cc'}} _hover={{background: '#0088cc'}}>
            <FaArrowLeftLong fontSize="16px" style={{marginRight: '8px'}} />
            Back
          </Button>
        </NavLink>
      )}
    </Box>
  );
};

export default Footer;